import { FetchCollectionResult, FetchResultType } from '@/entities/FetchResult'
import { authorizedFetch } from '@/helpers/authorizedFetch'
import { trans } from '@/helpers/trans'
import { generateApiV3Url } from '@/helpers/url'

import { TransportationOption } from './TransportationOption'
import { transformV3ResponseToTransportationOptions } from './TransportationOptionTransformers'

export const getTransportationOptionsCall = async (): Promise<FetchCollectionResult<TransportationOption[], string>> => {
    try {
        const url = generateApiV3Url({ endpoint: '/transportation-options' })
        const response = await authorizedFetch(url)
        const data = transformV3ResponseToTransportationOptions(await response.json())

        if (! data) {
            return {
                status: response.status,
                type: FetchResultType.Error,
                error: trans('errors.unknownError'),
            }
        }

        return {
            amountOfPages: 1,
            status: response.status,
            type: FetchResultType.Success,
            data,
        }
    } catch (error) {
        console.error('[getTransportationOptionsCall]', error)

        return {
            status: 500,
            type: FetchResultType.Error,
            error: trans('errors.unknownError'),
        }
    }
}
